import { EmailOptional as _EmailOptional } from '../../../EmailOptional';
import { FormFieldHOC } from '../../../HOCs/FormField';
import * as inputs from '../withFormProps';
//TODO: fix the Generic typing of FormFieldHOC to avoid those any
export const TileCheckboxGroup = FormFieldHOC(inputs.TileCheckboxGroup as any);
export const TileRadioGroup = FormFieldHOC(inputs.TileRadioGroup as any);
export const Checkbox = FormFieldHOC(inputs.Checkbox as any);
export const CheckboxGroup = FormFieldHOC(inputs.CheckboxGroup as any);

export const RadioGroup = FormFieldHOC(inputs.RadioGroup as any);
export const RadioCard = FormFieldHOC(inputs.RadioCard as any);
export const UnitInput = FormFieldHOC(inputs.UnitInput as any);
//TODO: make it standard
export const EmailOptional = FormFieldHOC(_EmailOptional as any);

export const BasicInput = FormFieldHOC(inputs.BasicInput);
export const Select = FormFieldHOC(inputs.Select);
export const NoValidationInput = FormFieldHOC(inputs.NoValidationInput);
export const DateInput = FormFieldHOC(inputs.DateInput);

type SelectProps = inputs.SelectProps;

export type { SelectProps };
